<template>
    <div class="flex flex-col gap-1.25 text-xs leading-none">
        <div class="flex flex-row items-center gap-2">
            <DeskIcon class="size-3.5 shrink-0 text-gray-500" />
            <span v-if="props.room && props.variant !== 'Disabled'" class="text-gray-600 font-normal">
                {{ props.room }}
            </span>
            <span v-else-if="props.room && props.variant === 'Disabled'" class="text-gray-500 font-light">
                {{ props.room }}
            </span>
            <span v-else class="text-gray-500 font-light">(nicht verfügbar)</span>
        </div>
        <div class="flex flex-row items-center gap-2">
            <MailIcon class="size-3.5 shrink-0 text-gray-500" />
            <span v-if="props.email && props.variant !== 'Disabled'" class="text-gray-600 font-normal">
                {{ props.email }}
            </span>
            <span v-else-if="props.email && props.variant === 'Disabled'" class="text-gray-500 font-light">
                {{ props.email }}
            </span>
            <span v-else class="text-gray-500 font-light">(nicht verfügbar)</span>
        </div>
        <div class="flex flex-row items-center gap-2">
            <CallIcon class="size-3.5 shrink-0 text-gray-500" />
            <span v-if="props.phone && props.variant !== 'Disabled'" class="text-gray-600 font-normal">
                {{ props.phone }}
            </span>
            <span v-else-if="props.phone && props.variant === 'Disabled'" class="text-gray-500 font-light">
                {{ props.phone }}
            </span>
            <span v-else class="text-gray-500 font-light">(nicht verfügbar)</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import CallIcon from '../Icon/CallIcon.vue';
import DeskIcon from '../Icon/DeskIcon.vue';
import MailIcon from '../Icon/MailIcon.vue';

type ContactInfoProps = {
    room?: string;
    email?: string;
    phone?: string;
    variant?: 'Default' | 'Disabled';
};

const props = defineProps<ContactInfoProps>();
</script>
